import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  postInventoryDetails,
  getShipDetails,
  updateShip,
  searchShipMgmt
} from "../Actions/ShipManagementAPI";
import axios from "axios";
import API from "../helpers/api";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import { toast } from "react-toastify";
import Role from "../helpers/role";

let user = JSON.parse(localStorage.getItem("currentUser"));
let userRole = localStorage.getItem("UserRoles");

let searchData = {
  ShipName: "",
  PageNumber: 1,
  PageSize: 25,
  isActive: true,
  isInactive: false,
  isAll: false
};
class ShipManagementDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
    };
  }
  componentDidMount() {
    const { match, dispatch } = this.props;
    const { params } = match;
    const { id } = params;
    dispatch(getShipDetails(id));
    //    dispatch(getShipEquipmentDetails(id));
  }
  componentDidUpdate() {
    const { dispatch, match } = this.props;
    window.onpopstate = (e) => {
      //your code...
      this.props.dispatch({ type: "ShowSidePan", data: false });
      this.props.history.push("/Home/Management/Ship");
    };
  }
  hideSidePanel = () => {
    this.setState({ showSidePane: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/Ship");
  };
  render() {
    const { ShipDetails } = this.props;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row pt-4 pb-3"></div>
          <div className="row pt-3">
            <div className="col-lg-12">
              <div className="resource-list-auth-date">
                <div className="panel-box search-filter-box">
                  <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                    onClick={() => this.hideSidePanel()}
                  >
                    <div style={{ position: 'relative' }}>
                      <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Return</span>
                    </div>
                  </button>
                  <div
                    className="card mt-2 MM-card-header"
                    style={{ backgroundColor: "white" }}
                  >
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        Basic Details
                      </h5>
                    </div>
                    <div className="pt-3 pb-3 search-filter-box">
                      <div className="row">
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>Ship Name : </strong>
                            {ShipDetails ? ShipDetails.shipName : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>IMO No : </strong>
                            {ShipDetails ? ShipDetails.imoNo : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>Ship Email : </strong>
                            {ShipDetails ? ShipDetails.shipMail : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>Vessel Group Email : </strong>
                            {ShipDetails
                              ? ShipDetails.vesselGroupMail
                              : ""}{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        Company Details
                      </h5>
                    </div>
                    <div className="pt-3 pb-3 search-filter-box">
                      <div className="row">
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>Client Name : </strong>
                            {ShipDetails ? ShipDetails.clientName : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>Marine Manager : </strong>
                            {ShipDetails ? ShipDetails.fleetManager : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <span>
                            <strong>Marine Superintendent : </strong>
                            {ShipDetails ? ShipDetails.superIntendent : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <span>
                            <strong>DPA : </strong>
                            {ShipDetails
                              ? ShipDetails.technicalExecutive
                              : ""}{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 pb-2 pt-2">
                      <div
                        className="search-btn-col mt-1"
                        style={{ textAlign: "right" }}
                      >
                        {userRole == Role.mmpl ? (<>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.hideSidePanel()}
                          >
                            {" "}
                            Cancel{" "}
                          </button>
                        </>) : (<>
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.EditShipDetails()}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.DeleteShipDetails()}
                          >
                            {" "}
                            Delete{" "}
                          </button>
                        </>)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  EditShipDetails() {
    const { match, dispatch, ShipDetails } = this.props;

    const { params } = match;
    const { id } = params;
    this.props.history.push(`/Home/Management/ShipEdit/${id}`);
    this.props.dispatch({ type: "ShowSidePan", data: false });
    dispatch({ type: "companyName", data: ShipDetails.clientName });
  }
  DeleteShipDetails() {
    //     const { ShipDetails, PaintCoating, EquipmentMachinery, StructureAndHull, Store, pagesearch, match, dispatch } = this.props;
    //     const { params } = match;
    //     const { id } = params;
    //     let invent1 = PaintCoating.map(r1 => {
    //         r1.isDeleted = true;
    //         return r1
    //     })
    //     let invent2 = EquipmentMachinery.map(r2 => {
    //         r2.isDeleted = true;
    //         return r2
    //     })
    //     let invent3 = StructureAndHull.map(r3 => {
    //         r3.isDeleted = true;
    //         return r3
    //     })
    //     let invent4 = Store.map(r4 => {
    //         r4.isDeleted = true;
    //         return r4
    //     })
    //     let ship = {
    //         shipId: parseInt(id),
    //         shipName: ShipDetails.shipName,
    //         clientName: ShipDetails.companyName,
    //         imoNo: ShipDetails.imoNo,
    //         flagName: ShipDetails.flag,
    //         className: ShipDetails.class,
    //         shipEmail: ShipDetails.shipEmail,
    //         vesselGroupEmail: ShipDetails.vesselGroupEmail,
    //         invoiceForwardingEmail: ShipDetails.invoiceForwardingEmail,
    //         phone1: ShipDetails.phone1,
    //         phone2: ShipDetails.phone2,
    //         hkcIssuedBy: ShipDetails.hkcIssuedBy,
    //         hkcIssuedDate: ShipDetails.hkcIssuedDate,
    //         eussrAttachmentName: ShipDetails.eussrAttachmentName,
    //         eussrAttachmentGuid: ShipDetails.eussrAttachmentGuid,
    //         hkcAttachmentName: ShipDetails.hkcAttachmentName,
    //         hkcAttachmentGuid: ShipDetails.hkcAttachmentGuid,
    //         hkcExpiryDate: ShipDetails.hkcExpiryDate,
    //         euSSRIssuedBy: ShipDetails.euSSRIssuedBy,
    //         euSSRIssuedDate: ShipDetails.euSSRIssuedDate,
    //         euSSRExpiryDate: ShipDetails.euSSRExpiryDate,
    //         isDeleted: true,
    //         modifiedBy: "",
    //         shipUsers: [
    //             {
    //                 userName: ShipDetails.fleetManager,
    //                 role: "fleetmanager"
    //             },
    //             {
    //                 userName: ShipDetails.technicalSuperintendent,
    //                 role: "superintendent"
    //             },
    //             {
    //                 userName: ShipDetails.technicalExecutive,
    //                 role: "technicalexecutive"
    //             }
    //         ]
    //     }
    //     let inventory = {
    //         shipId: parseInt(id),
    //         paintAndCoating: invent1,
    //         equipmentAndMachinery: invent2,
    //         structureAndHull: invent3,
    //         store: invent4
    //     }
    //     let url = `${API.postShip}`;
    //     axios.put(url, ship, {
    //         headers: {
    //             key: user.accessToken,
    //         }
    //     })
    //         .then((response) => {
    //             // dispatch(postInventoryDetails(inventory));
    //             this.hideSidePanel()
    //             // dispatch(getShipManagementList(searchData));
    //             dispatch({
    //                 type: "deleteShipDetailsSuccess",
    //                 data: response.data,
    //             })
    //         })
    //         .catch((error) => {
    //             dispatch({
    //                 type: "deleteShipDetailsFailure",
    //                 error: "ERROR"
    //             })
    //         })

    //     //  this.props.dispatch(deleteShipManagementDetails(ship, pagesearch));
    //     this.props.dispatch({ type: "ShowSidePan", data: false });
    //     this.props.history.goBack();
    // }
    const { ShipDetails, dispatch, match } = this.props;
    const { params } = match;
    const { id } = params;
    confirmAlert({
      message: "Are you sure want to delete?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            let shipInfo = {
              shipId: ShipDetails.shipId,
              shipName: ShipDetails.shipName,
              imoNo: ShipDetails.imoNo,
              shipMail: ShipDetails.shipMail,
              isDeleted: true,
              modifiedBy: "",
              picContactDetails: ShipDetails.picContactDetails,
              clientName: ShipDetails.clientName,
              shipUsers: [
                {
                  userName: ShipDetails.fleetManager,
                  role: "fleetmanager",
                },
                {
                  userName: ShipDetails.superIntendent,
                  role: "superintendent",
                },
                {
                  userName: ShipDetails.technicalExecutive,
                  role: "technicalexecutive",
                },
              ],
            };
            let user = JSON.parse(localStorage.getItem("currentUser"));
            let data = {
              shipId: ShipDetails.shipId,
              shipName: ShipDetails.shipName,
              imoNo: ShipDetails.imoNo,
              shipMail: ShipDetails.shipMail,
              vesselGroupMail: ShipDetails.vesselGroupMail,
              isDeleted: true,
              modifiedBy: user.email,
              clientName: ShipDetails.clientName,
              shipUsers: [
                {
                  userName: ShipDetails.fleetManager,
                  role: "fleetmanager",
                },
                {
                  userName: ShipDetails.superIntendent,
                  role: "superintendent",
                },
                {
                  userName: ShipDetails.technicalExecutive,
                  role: "technicalexecutive",
                },
              ],
            };
            dispatch(updateShip(data));
            this.hideSidePanel();
            dispatch(searchShipMgmt(searchData));
            toast.success("Deleted Successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
      overlayClassName: 'custom-alert'
    });

  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    ShowMISidePan: state.SidePanReducer.ShowMISidePan || false,
    ShowRDSidePan: state.SidePanReducer.ShowRDSidePan || false,
    ShowEURegSidePan: state.SidePanReducer.ShowEURegSidePan || false,
    ShipDetails: state.POViewReducer.ShipDetails,
    ShipEquipment: state.MasterScreenReducer.ShipEquipmentDetails,
    PaintCoating: state.MMPLDashboardReducer.PaintCoating,
    EquipmentMachinery: state.MMPLDashboardReducer.EquipmentMachinery,
    StructureAndHull: state.MMPLDashboardReducer.StructureAndHull,
    Store: state.MMPLDashboardReducer.Store,
    pagesearch: state.MasterScreenReducer.pagesearch,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShipManagementDetail)
);
